/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { DataSourceLoadOptionsBase } from '../models/data-source-load-options-base';
import { DonDto } from '../models/don-dto';
import { IncidentsVisiteDto } from '../models/incidents-visite-dto';
import { LoadResult } from '../models/load-result';
import { VisiteDto } from '../models/visite-dto';


/**
 * Fonctions de gestion des visites
 */
@Injectable({
  providedIn: 'root',
})
export class VisitesService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation visiteGetList
   */
  static readonly VisiteGetListPath = '/api/visites/list';

  /**
   * Renvoie la liste des visites.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `visiteGetList()` instead.
   *
   * This method doesn't expect any request body.
   */
  visiteGetList$Response(params?: {
  }): Observable<StrictHttpResponse<Array<VisiteDto>>> {

    const rb = new RequestBuilder(this.rootUrl, VisitesService.VisiteGetListPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<VisiteDto>>;
      })
    );
  }

  /**
   * Renvoie la liste des visites.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `visiteGetList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  visiteGetList(params?: {
  }): Observable<Array<VisiteDto>> {

    return this.visiteGetList$Response(params).pipe(
      map((r: StrictHttpResponse<Array<VisiteDto>>) => r.body as Array<VisiteDto>)
    );
  }

  /**
   * Path part for operation visiteLoadList
   */
  static readonly VisiteLoadListPath = '/api/visites/load-list';

  /**
   * Renvoie la liste des visites (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `visiteLoadList()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  visiteLoadList$Response(params: {

    /**
     * Identifiant du parc
     */
    parcId?: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<StrictHttpResponse<LoadResult>> {

    const rb = new RequestBuilder(this.rootUrl, VisitesService.VisiteLoadListPath, 'post');
    if (params) {
      rb.query('parcId', params.parcId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LoadResult>;
      })
    );
  }

  /**
   * Renvoie la liste des visites (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `visiteLoadList$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  visiteLoadList(params: {

    /**
     * Identifiant du parc
     */
    parcId?: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<LoadResult> {

    return this.visiteLoadList$Response(params).pipe(
      map((r: StrictHttpResponse<LoadResult>) => r.body as LoadResult)
    );
  }

  /**
   * Path part for operation visiteGet
   */
  static readonly VisiteGetPath = '/api/visites/{id}';

  /**
   * Renvoie la visite spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `visiteGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  visiteGet$Response(params: {

    /**
     * Identifiant de la visite
     */
    id: number;
  }): Observable<StrictHttpResponse<VisiteDto>> {

    const rb = new RequestBuilder(this.rootUrl, VisitesService.VisiteGetPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<VisiteDto>;
      })
    );
  }

  /**
   * Renvoie la visite spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `visiteGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  visiteGet(params: {

    /**
     * Identifiant de la visite
     */
    id: number;
  }): Observable<VisiteDto> {

    return this.visiteGet$Response(params).pipe(
      map((r: StrictHttpResponse<VisiteDto>) => r.body as VisiteDto)
    );
  }

  /**
   * Path part for operation visitePut
   */
  static readonly VisitePutPath = '/api/visites/{id}';

  /**
   * Met à jour la visite spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `visitePut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  visitePut$Response(params: {

    /**
     * Identifiant de la visite à mettre à jour
     */
    id: number;

    /**
     * Visite
     */
    body: VisiteDto
  }): Observable<StrictHttpResponse<VisiteDto>> {

    const rb = new RequestBuilder(this.rootUrl, VisitesService.VisitePutPath, 'put');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<VisiteDto>;
      })
    );
  }

  /**
   * Met à jour la visite spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `visitePut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  visitePut(params: {

    /**
     * Identifiant de la visite à mettre à jour
     */
    id: number;

    /**
     * Visite
     */
    body: VisiteDto
  }): Observable<VisiteDto> {

    return this.visitePut$Response(params).pipe(
      map((r: StrictHttpResponse<VisiteDto>) => r.body as VisiteDto)
    );
  }

  /**
   * Path part for operation visiteDelete
   */
  static readonly VisiteDeletePath = '/api/visites/{id}';

  /**
   * Supprime la visite spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `visiteDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  visiteDelete$Response(params: {

    /**
     * Identifiant de la visite à supprimer
     */
    id: number;
  }): Observable<StrictHttpResponse<number>> {

    const rb = new RequestBuilder(this.rootUrl, VisitesService.VisiteDeletePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: parseFloat(String((r as HttpResponse<any>).body)) }) as StrictHttpResponse<number>;
      })
    );
  }

  /**
   * Supprime la visite spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `visiteDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  visiteDelete(params: {

    /**
     * Identifiant de la visite à supprimer
     */
    id: number;
  }): Observable<number> {

    return this.visiteDelete$Response(params).pipe(
      map((r: StrictHttpResponse<number>) => r.body as number)
    );
  }

  /**
   * Path part for operation visitePost
   */
  static readonly VisitePostPath = '/api/visites';

  /**
   * Crée la visite spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `visitePost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  visitePost$Response(params: {

    /**
     * Visite
     */
    body: VisiteDto
  }): Observable<StrictHttpResponse<VisiteDto>> {

    const rb = new RequestBuilder(this.rootUrl, VisitesService.VisitePostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<VisiteDto>;
      })
    );
  }

  /**
   * Crée la visite spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `visitePost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  visitePost(params: {

    /**
     * Visite
     */
    body: VisiteDto
  }): Observable<VisiteDto> {

    return this.visitePost$Response(params).pipe(
      map((r: StrictHttpResponse<VisiteDto>) => r.body as VisiteDto)
    );
  }

  /**
   * Path part for operation visiteCloseVisite
   */
  static readonly VisiteCloseVisitePath = '/api/visites/{id}/close';

  /**
   * Clôture la visite spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `visiteCloseVisite()` instead.
   *
   * This method doesn't expect any request body.
   */
  visiteCloseVisite$Response(params: {

    /**
     * Identifiant de la visite à clôturer
     */
    id: number;
  }): Observable<StrictHttpResponse<VisiteDto>> {

    const rb = new RequestBuilder(this.rootUrl, VisitesService.VisiteCloseVisitePath, 'post');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<VisiteDto>;
      })
    );
  }

  /**
   * Clôture la visite spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `visiteCloseVisite$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  visiteCloseVisite(params: {

    /**
     * Identifiant de la visite à clôturer
     */
    id: number;
  }): Observable<VisiteDto> {

    return this.visiteCloseVisite$Response(params).pipe(
      map((r: StrictHttpResponse<VisiteDto>) => r.body as VisiteDto)
    );
  }

  /**
   * Path part for operation visiteGetLast
   */
  static readonly VisiteGetLastPath = '/api/visites/{parcId}/last';

  /**
   * Récupère les dernières visites du parc spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `visiteGetLast()` instead.
   *
   * This method doesn't expect any request body.
   */
  visiteGetLast$Response(params: {

    /**
     * Identifiant du parc
     */
    parcId: number;
  }): Observable<StrictHttpResponse<Array<VisiteDto>>> {

    const rb = new RequestBuilder(this.rootUrl, VisitesService.VisiteGetLastPath, 'get');
    if (params) {
      rb.path('parcId', params.parcId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<VisiteDto>>;
      })
    );
  }

  /**
   * Récupère les dernières visites du parc spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `visiteGetLast$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  visiteGetLast(params: {

    /**
     * Identifiant du parc
     */
    parcId: number;
  }): Observable<Array<VisiteDto>> {

    return this.visiteGetLast$Response(params).pipe(
      map((r: StrictHttpResponse<Array<VisiteDto>>) => r.body as Array<VisiteDto>)
    );
  }

  /**
   * Path part for operation visiteIncidentsLoadList
   */
  static readonly VisiteIncidentsLoadListPath = '/api/visites/incidents/load-list/{visiteId}';

  /**
   * Renvoie la liste des incidents d'une visite (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `visiteIncidentsLoadList()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  visiteIncidentsLoadList$Response(params: {

    /**
     * Identifiant de la visite
     */
    visiteId: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<StrictHttpResponse<LoadResult>> {

    const rb = new RequestBuilder(this.rootUrl, VisitesService.VisiteIncidentsLoadListPath, 'post');
    if (params) {
      rb.path('visiteId', params.visiteId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LoadResult>;
      })
    );
  }

  /**
   * Renvoie la liste des incidents d'une visite (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `visiteIncidentsLoadList$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  visiteIncidentsLoadList(params: {

    /**
     * Identifiant de la visite
     */
    visiteId: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<LoadResult> {

    return this.visiteIncidentsLoadList$Response(params).pipe(
      map((r: StrictHttpResponse<LoadResult>) => r.body as LoadResult)
    );
  }

  /**
   * Path part for operation visiteGetIncident
   */
  static readonly VisiteGetIncidentPath = '/api/visites/incidents/{visiteId}/{incidentId}';

  /**
   * Renvoie l'incident spécifié pour la visite spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `visiteGetIncident()` instead.
   *
   * This method doesn't expect any request body.
   */
  visiteGetIncident$Response(params: {

    /**
     * Identifiant de la visite
     */
    visiteId: number;

    /**
     * Identifiant de l&#x27;incident
     */
    incidentId: number;
  }): Observable<StrictHttpResponse<IncidentsVisiteDto>> {

    const rb = new RequestBuilder(this.rootUrl, VisitesService.VisiteGetIncidentPath, 'get');
    if (params) {
      rb.path('visiteId', params.visiteId, {});
      rb.path('incidentId', params.incidentId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<IncidentsVisiteDto>;
      })
    );
  }

  /**
   * Renvoie l'incident spécifié pour la visite spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `visiteGetIncident$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  visiteGetIncident(params: {

    /**
     * Identifiant de la visite
     */
    visiteId: number;

    /**
     * Identifiant de l&#x27;incident
     */
    incidentId: number;
  }): Observable<IncidentsVisiteDto> {

    return this.visiteGetIncident$Response(params).pipe(
      map((r: StrictHttpResponse<IncidentsVisiteDto>) => r.body as IncidentsVisiteDto)
    );
  }

  /**
   * Path part for operation visiteUpdateDonnerie
   */
  static readonly VisiteUpdateDonneriePath = '/api/visites/donnerie';

  /**
   * Mets à jour le don pour la visite spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `visiteUpdateDonnerie()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  visiteUpdateDonnerie$Response(params: {

    /**
     * Don
     */
    body: DonDto
  }): Observable<StrictHttpResponse<DonDto>> {

    const rb = new RequestBuilder(this.rootUrl, VisitesService.VisiteUpdateDonneriePath, 'put');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<DonDto>;
      })
    );
  }

  /**
   * Mets à jour le don pour la visite spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `visiteUpdateDonnerie$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  visiteUpdateDonnerie(params: {

    /**
     * Don
     */
    body: DonDto
  }): Observable<DonDto> {

    return this.visiteUpdateDonnerie$Response(params).pipe(
      map((r: StrictHttpResponse<DonDto>) => r.body as DonDto)
    );
  }

  /**
   * Path part for operation visiteAddDonnerie
   */
  static readonly VisiteAddDonneriePath = '/api/visites/donnerie';

  /**
   * Crée le don pour la visite spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `visiteAddDonnerie()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  visiteAddDonnerie$Response(params: {

    /**
     * Don
     */
    body: DonDto
  }): Observable<StrictHttpResponse<DonDto>> {

    const rb = new RequestBuilder(this.rootUrl, VisitesService.VisiteAddDonneriePath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<DonDto>;
      })
    );
  }

  /**
   * Crée le don pour la visite spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `visiteAddDonnerie$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  visiteAddDonnerie(params: {

    /**
     * Don
     */
    body: DonDto
  }): Observable<DonDto> {

    return this.visiteAddDonnerie$Response(params).pipe(
      map((r: StrictHttpResponse<DonDto>) => r.body as DonDto)
    );
  }

}
